<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
    <default-heading text="New Recommendation" class="mt-3">
      <template #right>
        <b-button
          variant="success"
          class="ml-1"
          :to="`/results/${result_id}`"
        >
          <i class="fal fa-arrow-left" />
        </b-button>
      </template>
    </default-heading>

    <div class="my-3">
      <RecommendationForm :submittingForm="submittingForm" :error="error" @submit="submit" />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import RecommendationForm from '@/components/results/recommendation/RecommendationForm'
import RecommendationModel from '@/models/result/RecommendationModel'
import ResultModel from '@/models/result/ResultModel'

export default {
  name: 'ResultAddRecommendation',
  components: {
    DefaultHeading,
    RecommendationForm
  },
  data () {
    return {
      loading: false,
      result_id: this.$route.params.id || null,
      result: null,
      error: null,
      submittingForm: false
    }
  },
  mounted () {
    this.fetchResult()
  },
  methods: {
    fetchResult () {
      const model = new ResultModel({ id: this.result_id })
      model.fetch().then(({ response }) => {
        this.result = response.data
        this.loading = false
      })
    },

    async submit (form_data) {
      this.error = null
      this.submittingForm = true

      try {
        const recommendationModel = new RecommendationModel({
          ...form_data,
          result_id: this.result_id
        })

        const { response } = await recommendationModel.save()

        this.$bvToast.toast('Recommendation Created', {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1000
        })
        this.$router.push('/results/' + this.result_id)
      } catch (err) {
        if (err.response && err.response.response && err.response.response.data && err.response.response.data.message) {
          this.error = err.response.response.data.message
        } else {
          this.error = err.err || 'Something went wrong please try again'
        }
      }

      this.submittingForm = false
    }
  }
}
</script>
